import * as React from "react";
function SvgEnvelopes(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M44.4 3.7H14.2c-1.7 0-3.1 1.4-3.2 3.1v11.7H2.6c-1.3 0-2.6.6-2.6 2v20.3c0 1.4 1.2 3.6 2.6 3.6h32.9c1.4 0 2.7-2.2 2.7-3.6V29.5h6.3c2-.2 3.6-1.8 3.6-3.8V7.1c-.2-1.9-1.8-3.5-3.7-3.4zM14.2 6.2h30.2c.1-.1.2-.2.3-.2L29.3 16.1 14.1 5.9l.1.3zm18.5 11.6h-1.8l1-.7.8.7zm-5 0H26l.8-.6.9.6zM13.5 8.2L24.6 16l-2.5 2.5h-8.6V8.2zm9.6 12.7h10.5L19 30.8 4.6 20.9h18.5zm12.6 18.6l-12-9.6 12-8v17.6zM2.5 40V21.8l11.9 8.1L2.5 40zm14-8.3l2.5 1.6 2.6-1.5 12.3 10.1H4.8l11.7-10.2zm21.7-4.6v-4.9l5.4 4.9h-5.4zm7.3-2.2L34 15.7 45.5 8v16.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEnvelopes);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
